import { CustomerList } from 'src/features/customers/CustomerList'

const CustomerListScreen = () => {
    return <CustomerList />
}

CustomerListScreen.guestGuard = false;
CustomerListScreen.authGuard = true;


export { CustomerListScreen }
export default CustomerListScreen